import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError, retry, map } from 'rxjs/operators';
import { Socket } from 'ngx-socket-io';
 
@Injectable()
export class NotificationService {
 
    constructor(
    	private socket: Socket,
    	private http: HttpClient
    ) {}
 
    /*sendMessage(msg: string){
        this.socket.emit("message", msg);
    }*/
    getPrivilage() {
        return this.socket.fromEvent("privilage")
            .pipe(map(data => {
            	console.log(data);
                return data;
            }));
    }
}